import { Component, OnInit } from '@angular/core';
import { AgilityRiskService } from '../../providers/agility-risk.service';
import { AgilityRiskPermissionService } from '../../providers/agility-risk-permission.service';
import { AgilityRiskEventService } from '../../providers/agility-risk-event.service';
import { permissions } from '../../agility-risk.constants';
import { NgxPermissionsService } from 'ngx-permissions';

@Component({
  selector: 'lib-agility-risk-test',
  templateUrl: './agility-risk-test.component.html',
  styleUrls: ['./agility-risk-test.component.scss']
})
export class AgilityRiskTestComponent implements OnInit {
  permissions = permissions;

  get canViewThreat(): boolean {
    return this.permissionService.canAccessRisk;
  }

  hasAdminRole: boolean = false;

  constructor(private riskService: AgilityRiskService,
              private permissionService: AgilityRiskPermissionService,
              private ngxPermissionService: NgxPermissionsService,
              private eventService: AgilityRiskEventService,) {
  }

  ngOnInit(): void {
    console.log('test page init');
    this.ngxPermissionService.hasPermission([
      permissions.isSuperAdmin,
      permissions.isAdmin,
      permissions.isManager
    ]).then((hasPermission: boolean) => {
      this.hasAdminRole = hasPermission;
    });
  }

  test(): void {
    this.eventService.moduleChanged({});
  }
}
